import { render, staticRenderFns } from "./BlackbookList.vue?vue&type=template&id=15a7612a&scoped=true&"
import script from "./BlackbookList.vue?vue&type=script&lang=js&"
export * from "./BlackbookList.vue?vue&type=script&lang=js&"
import style0 from "./BlackbookList.vue?vue&type=style&index=0&id=15a7612a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7612a",
  null
  
)

export default component.exports